import React from 'react'
import MaterialSymbol from '../material-symbol'

const MonetizationOn = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="monetization_on" {...props} />
))

MonetizationOn.displayName = 'MonetizationOn'

export default MonetizationOn
